import axios from "axios";

export default {
  namespaced: true,
    state: {
        lista: [],
        perPage: 100,
        SEQUENCIA: null,
        CODIGO: null,
        DESCRICAO: null,
        registroSelecionadoId: null,
        paginaAtual: 1,
    },
    getters: {
      LISTA: state => state.lista,
      PER_PAGE: state => state.perPage,
      SEQUENCIA: state => state.SEQUENCIA,
      CODIGO: state => state.CODIGO,
      DESCRICAO: state => state.DESCRICAO,
      REGISTRO_SELECIONADO_ID: state => state.registroSelecionadoId,
      PAGINA_ATUAL: state => state.paginaAtual
    },
    mutations: {
      SET_LISTA: (state, payload) => { state.lista = payload },
      SET_PER_PAGE: (state, payload) => { state.perPage = payload },
      SET_SEQUENCIA: (state, payload) => { state.SEQUENCIA = payload },
      SET_CODIGO: (state, payload) => { state.CODIGO = payload },
      SET_DESCRICAO: (state, payload) => { state.DESCRICAO = payload },
      SET_REGISTRO_SELECIONADO_ID: (state, payload) => { state.registroSelecionadoId = payload },
      SET_PAGINA_ATUAL: (state, payload) => { state.paginaAtual = payload },
      SET_LIMPAR: (state, payload) => {
        state.lista = [];
        state.SEQUENCIA = null;
        state.CODIGO = null;
        state.DESCRICAO = null;
        state.registroSelecionadoId = null;
        state.paginaAtual = 1;
      },
      SET_LIMPAR_APENAS_FILTRO: (state, payload) => {
          state.filtroAvancado = false;
          state.lista = [];
          state.paginaAtual = 1;
      }
  },
  actions: {
    GET_LISTA: ({ commit, getters }) => {
      return new Promise((resolve, reject) => {
        const filtros = {
            SEQUENCIA: getters.SEQUENCIA ?? null,
            CODIGO: getters.CODIGO ?? null,
            DESCRICAO: getters.DESCRICAO ?? null
        }

        axios.post(`/api/protected/centrocusto/pesquisar`, filtros)
        .then(({ data, status }) => {
            commit("SET_LISTA", data);
            if (status === 200 || status === 201) {
                resolve({ data, status });
            }
        })
        .catch(error => {
          reject(error)
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modulos/centrocusto-store.js